<template>
  <div v-if="!loading">
    <page-header>
      <template #title>
        <h1 class="page-title" v-text="pageTitle"></h1>
      </template>
    </page-header>

    <div class="card mb-3">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend class="small-legend">Details</legend>
              <!--              <inputbox-->
              <!--                  v-model="form.penalty_reference"-->
              <!--                  name="penalty_reference"-->
              <!--                  label="Penalty Reference"-->
              <!--                  :required="true"-->
              <!--              ></inputbox>-->
              <inputbox
                v-model="form.external_reference"
                name="external_reference"
                label="External Reference"
                :required="true"
                :show-error="form.errors.has('external_reference')"
                :error-message="form.errors.get('external_reference')"
              ></inputbox>

              <selectlist
                v-model="form.issuing_authority_id"
                name="issuing_authority_id"
                label="Issuing Authority"
                :options="issuingAuthorities"
                label-name="name"
              ></selectlist>

              <selectlist
                v-model="form.penalty_type_id"
                name="penalty_type_id"
                label="Type"
                :options="penaltyTypes"
              ></selectlist>

              <fleet-vehicle-lookup
                v-model="form.vehicle_id"
                label="Vehicle"
                :vehicle="penalty?.vehicle"
              ></fleet-vehicle-lookup>

              <datepicker-input
                v-model="form.date_of_contravention"
                name="date_of_contravention"
                label="Date Of Contravention"
                :disabled="dateRange"
              ></datepicker-input>

              <div class="form-group">
                <div class="col-lg-4">
                  <label class="control-label">In Dispute?</label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    v-model="form.in_dispute"
                    name="in_dispute"
                    :labels="true"
                  ></toggleswitch>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend class="small-legend">Recharge To Customer</legend>

              <currency-input
                v-model="form.recharge_amount"
                name="recharge_amount"
                label="Recharge Amount"
              ></currency-input>

              <currency-input
                v-model="form.recharge_admin_amount"
                name="recharge_admin_amount"
                label="Recharge Admin Amount (Net)"
              ></currency-input>

              <currency-input
                v-model="form.recharge_admin_amount_vat"
                name="recharge_admin_amount_vat"
                label="Recharge Admin Amount (VAT)"
              ></currency-input>

              <currency-input
                v-model="form.total_recharge_amount"
                name="total_recharge_amount"
                label="Total Recharge Amount"
              ></currency-input>

              <currency-input
                v-model="form.customer_admin_fee_paid_gross_amount"
                name="customer_admin_fee_paid_gross_amount"
                label="Customer Admin Fee Paid Gross Amount"
              ></currency-input>

              <datepicker-input
                v-model="form.invoice_date"
                name="invoice_date"
                label="Invoice Date"
                :disabled="dateRange"
              ></datepicker-input>

              <currency-input
                v-model="form.recharge_paid_amount"
                name="recharge_paid_amount"
                label="Recharge Paid Amount"
              ></currency-input>

              <div class="form-group">
                <div class="col-lg-4">
                  <label class="control-label">Settled?</label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    v-model="form.settled"
                    name="settled"
                    :labels="true"
                  ></toggleswitch>
                </div>
              </div>

              <datepicker-input
                v-model="form.settled_date"
                name="settled_date"
                label="Settled Date"
                :disabled="dateRange"
              ></datepicker-input>
            </fieldset>
          </div>

          <div class="col-lg-6">
            <fieldset>
              <legend class="small-legend">Process</legend>

              <hire-lookup
                v-model="form.hire_id"
                label="Hire"
                :hire="penalty?.hire"
                :date="form.date_of_contravention"
                :vehicle-id="form.vehicle_id"
                @selected="setHire"
              ></hire-lookup>

              <selectlist
                v-model="form.driver_id"
                name="driver_id"
                label="Driver"
                :options="penalty?.hire?.drivers || []"
                label-name="name"
              ></selectlist>

              <div class="form-group">
                <div class="col-lg-4">
                  <label class="control-label">Representations</label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    v-model="form.representations"
                    name="representations"
                    :labels="true"
                  ></toggleswitch>
                </div>
              </div>

              <template v-if="form.representations">
                <div class="form-group">
                  <div class="col-lg-4">
                    <label class="control-label">Representation Sent</label>
                  </div>
                  <div class="col-lg-8">
                    <toggleswitch
                      v-model="form.representation_sent"
                      name="representations"
                      :labels="true"
                    ></toggleswitch>
                  </div>
                </div>

                <datepicker-input
                  v-model="form.representation_sent_at"
                  name="representation_sent_at"
                  label="Representation Sent Date"
                  :disabled="dateRange"
                  v-if="form.representation_sent"
                ></datepicker-input>

                <datepicker-input
                  v-model="form.representation_accepted_at"
                  name="representation_accepted_at"
                  label="Representation Accepted Date"
                  :disabled="dateRange"
                ></datepicker-input>

                <div class="form-group">
                  <div class="col-lg-4">
                    <label class="control-label"
                      >Representation Rejected?</label
                    >
                  </div>
                  <div class="col-lg-8">
                    <toggleswitch
                      v-model="form.representation_rejected"
                      name="representation_rejected"
                      :labels="true"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-lg-4">
                    <label class="control-label">Resend Representation?</label>
                  </div>
                  <div class="col-lg-8">
                    <toggleswitch
                      v-model="form.resend_representation"
                      name="resend_representation"
                      :labels="true"
                    ></toggleswitch>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-lg-4">
                    <label class="control-label">Attach Scanned Copy?</label>
                  </div>
                  <div class="col-lg-8">
                    <toggleswitch
                      v-model="form.attach_scanned_copy"
                      name="attach_scanned_copy"
                      :labels="true"
                    ></toggleswitch>
                  </div>
                </div>
              </template>
            </fieldset>

            <fieldset>
              <legend class="small-legend">Potential Costs</legend>

              <currency-input
                v-model="form.potential_full_penalty_cost"
                name="potential_full_penalty_cost"
                label="Full Penalty Costs"
              ></currency-input>

              <currency-input
                v-model="form.potential_reduced_penalty_cost"
                name="potential_reduced_penalty_cost"
                label="Reduced Penalty Costs"
              ></currency-input>

              <currency-input
                v-model="form.potential_inflated"
                name="potential_inflated"
                label="Inflated Costs"
              ></currency-input>
            </fieldset>

            <fieldset>
              <legend class="small-legend">Actual Costs</legend>

              <div class="form-group">
                <div class="col-lg-4">
                  <label class="control-label">Penalty Paid?</label>
                </div>
                <div class="col-lg-8">
                  <toggleswitch
                    v-model="form.penalty_paid"
                    name="penalty_paid"
                    :labels="true"
                  ></toggleswitch>
                </div>
              </div>

              <selectlist
                v-model="form.payable_cost_id"
                name="payable_cost_id"
                label="Payable Cost"
                :options="payableCosts"
                label-name="label"
                @input="setPaidAmount"
              ></selectlist>

              <!--              <currency-input-->
              <!--                v-model="form.received_admin_fee"-->
              <!--                name="received_admin_fee"-->
              <!--                label="Received Admin Fee"-->
              <!--              ></currency-input>-->

              <!--              <currency-input-->
              <!--                v-model="form.received_admin_fee_vat"-->
              <!--                name="received_admin_fee_vat"-->
              <!--                label="Received Admin Fee (VAT)"-->
              <!--              ></currency-input>-->

              <currency-input
                v-model="form.paid_amount"
                name="paid_amount"
                label="Paid Amount"
              ></currency-input>

              <datepicker-input
                v-model="form.penalty_paid_at"
                name="penalty_paid_at"
                label="Penalty Paid Date"
                :disabled="dateRange"
              ></datepicker-input>

              <!--              <selectlist-->
              <!--                v-model="form.payment_method_id"-->
              <!--                name="payment_method_id"-->
              <!--                label="Payment Method"-->
              <!--                :options="paymentMethods"-->
              <!--                label-name="label"-->
              <!--              ></selectlist>-->

              <!--              <currency-input-->
              <!--                v-model="form.actual_total_costs"-->
              <!--                name="actual_total_costs"-->
              <!--                label="Actual Total Costs"-->
              <!--              ></currency-input>-->
            </fieldset>
          </div>
        </div>
      </div>

      <div class="card-footer text-right">
        <form-button :indicator="saving" @clicked="submit">
          <i class="icon icon-save"></i> Save
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
import HireLookup from '@/components/Modules/Penalties/Form/HireLookup';
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';
import PageHeader from './../Shared/PageHeader.vue';

export default {
  props: {
    identifier: {
      type: String
    }
  },

  components: {
    HireLookup,
    CurrencyInput,
    PageHeader
  },

  data() {
    return {
      penalty: {},
      loading: true,
      saving: false,
      dateRange: {
        from: new Date()
      },
      form: new window.Form({
        issuing_authority_id: null,
        penalty_type_id: null,
        vehicle_id: null,
        hire_id: null,
        driver_id: null,
        penalty_reference: null,
        external_reference: null,
        date_of_contravention: null,
        in_dispute: false,
        representations: false,
        representation_sent: null,
        representation_sent_at: null,
        representation_accepted_at: null,
        representation_rejected: false,
        resend_representation: false,
        attach_scanned_copy: false,
        potential_full_penalty_cost: null,
        potential_reduced_penalty_cost: null,
        potential_inflated: null,
        penalty_paid: false,
        penalty_paid_at: null,
        received_admin_fee: null,
        received_admin_fee_vat: null,
        paid_amount: null,
        payable_cost_id: null,
        payment_method_id: null,
        actual_total_costs: null,
        recharge_amount: null,
        recharge_admin_amount: null,
        recharge_admin_amount_vat: null,
        total_recharge_amount: null,
        customer_admin_fee_paid_gross_amount: null,
        invoice_date: null,
        recharge_paid_amount: null,
        settled: false,
        settled_date: null
      })
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },

    issuingAuthorities() {
      return this.$store.getters['Companies/issuingAuthorities'];
    },

    penaltyTypes() {
      return this.$store.getters['Penalties/types'];
    },

    payableCosts() {
      return this.$store.getters['Penalties/payableCosts'];
    },

    paymentMethods() {
      return this.$store.getters['Penalties/paymentMethods'];
    },

    pageTitle() {
      if (this.identifier) {
        return 'Update Penalty';
      }

      return 'New Penalty';
    }
  },

  mounted() {
    this.$store.commit('Companies/retrieve');
    this.$store.commit('Penalties/retrieveTypes');
    this.$store.commit('Penalties/retrievePayableCosts');
    this.$store.commit('Penalties/retrievePaymentMethods');

    if (this.identifier) {
      window.Ajax.get(`penalties/${this.identifier}?parts=vehicle,hire`).then(
        ({ data }) => {
          this.setPenalty(data);

          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  },

  methods: {
    submit() {
      if (this.identifier) {
        this.update();
      } else {
        this.create();
      }
    },

    create() {
      this.saving = true;

      this.form
        .post('penalties')
        .then(() => {
          this.saving = false;

          window.toastify.success(
            'Penalty Created',
            'The penalty was created successfully!'
          );

          this.$router.push('/penalties');
        })
        .catch(() => {
          this.saving = false;

          window.toastify.error(
            'Error',
            'There was a problem saving the penalty, please try again.'
          );
        });
    },

    update() {
      this.saving = true;

      this.form
        .put(`penalties/${this.identifier}`)
        .then(penalty => {
          this.saving = false;

          window.toastify.success(
            'Penalty Created',
            'The penalty was created successfully!'
          );
        })
        .catch(() => {
          this.saving = false;

          window.toastify.error(
            'Error',
            'There was a problem saving the penalty, please try again.'
          );
        });
    },

    setPenalty(penalty) {
      this.penalty = penalty;

      this.form.issuing_authority_id = this.penalty.issuing_authority_id;
      this.form.penalty_type_id = this.penalty.penalty_type_id;
      this.form.vehicle_id = this.penalty.vehicle_id;
      this.form.hire_id = this.penalty.hire_id;
      this.form.driver_id = this.penalty.driver_id;
      this.form.penalty_reference = this.penalty.penalty_reference;
      this.form.external_reference = this.penalty.external_reference;
      this.form.date_of_contravention = this.penalty.date_of_contravention;
      this.form.in_dispute = this.penalty.in_dispute;
      this.form.representations = this.penalty.representations;
      this.form.representation_sent = this.penalty.representation_sent;
      this.form.representation_sent_at = this.penalty.representation_sent_at;
      this.form.representation_accepted_at = this.penalty.representation_accepted_at;
      this.form.representation_rejected = this.penalty.representation_rejected;
      this.form.resend_representation = this.penalty.resend_representation;
      this.form.attach_scanned_copy = this.penalty.attach_scanned_copy;
      this.form.potential_full_penalty_cost = this.penalty.potential_full_penalty_cost;
      this.form.potential_reduced_penalty_cost = this.penalty.potential_reduced_penalty_cost;
      this.form.potential_inflated = this.penalty.potential_inflated;
      this.form.penalty_paid = this.penalty.penalty_paid;
      this.form.penalty_paid_at = this.penalty.penalty_paid_at;
      this.form.received_admin_fee = this.penalty.received_admin_fee;
      this.form.received_admin_fee_vat = this.penalty.received_admin_fee_vat;
      this.form.paid_amount = this.penalty.paid_amount;
      this.form.payable_cost_id = this.penalty.payable_cost_id;
      this.form.payment_method_id = this.penalty.payment_method_id;
      this.form.actual_total_costs = this.penalty.actual_total_costs;
      this.form.recharge_amount = this.penalty.recharge_amount;
      this.form.recharge_admin_amount = this.penalty.recharge_admin_amount;
      this.form.recharge_admin_amount_vat = this.penalty.recharge_admin_amount_vat;
      this.form.total_recharge_amount = this.penalty.total_recharge_amount;
      this.form.customer_admin_fee_paid_gross_amount = this.penalty.customer_admin_fee_paid_gross_amount;
      this.form.invoice_date = this.penalty.invoice_date;
      this.form.recharge_paid_amount = this.penalty.recharge_paid_amount;
      this.form.settled = this.penalty.settled;
      this.form.settled_date = this.penalty.settled_date;
    },

    setHire(hire) {
      this.penalty.hire = hire;
    },

    setPaidAmount(payableCost) {
      const cost = this.payableCosts.find(cost => cost.id === payableCost);

      if (cost?.name === 'inflated') {
        this.form.paid_amount = this.form.potential_inflated;
      } else if (cost?.name === 'reduced') {
        this.form.paid_amount = this.form.potential_reduced_penalty_cost;
      } else if (cost?.name === 'full_penalty') {
        this.form.paid_amount = this.form.potential_full_penalty_cost;
      }
    }
  },

  watch: {
    user: {
      handler(user) {
        // Here, we load the vehicle details from the vehicle id in the query string.
        // We only want to load the vehicle details once the user object is loaded and
        // if we aren't editing a penalty.
        if (user && !this.identifier && this.$route.query.vehicle_id) {
          window.Ajax.get(
            `/fleet/${user.tenant?.identifier}/${this.$route.query.vehicle_id}`
          )
            .then(({ data }) => {
              this.penalty.vehicle_id = data.id;
              this.penalty.vehicle = data;
              this.form.vehicle_id = data.id;
            })
            .catch(() => {});
        }
      },
      immediate: true
    }
  }
};
</script>
